const Coins = () => (
  <>
    <path
      fill="currentColor"
      d="M15.003 19q-2.93 0-4.966-2.033T8 12.003t2.034-4.966T14.997 5t4.967 2.034T22 11.997t-2.033 4.967T15.003 19m-8.705-.52a6.3 6.3 0 0 1-3.141-2.52Q2 14.182 2 12t1.157-3.96a6.3 6.3 0 0 1 3.141-2.52q.274-.117.489.033Q7 5.7 7 6.038a.4.4 0 0 1-.087.245.56.56 0 0 1-.219.176 5.64 5.64 0 0 0-2.692 2.178A5.95 5.95 0 0 0 3 12a5.95 5.95 0 0 0 1.002 3.363 5.64 5.64 0 0 0 2.692 2.178.6.6 0 0 1 .22.183.43.43 0 0 1 .086.262q0 .299-.213.454-.214.157-.489.04M15 18q2.5 0 4.25-1.75T21 12t-1.75-4.25T15 6t-4.25 1.75T9 12t1.75 4.25T15 18"
    />
  </>
)
export default Coins
